import React from 'react'
//import withRouter from 'react-router/withRouter'
import { useHistory, withRouter } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles'
import LanguageIcon from '@material-ui/icons/Language'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import { MenuItem, ListItemText } from '@material-ui/core'
import { languageProps, LANGUAGE_SHORT_CODE } from '../../../constants'
import { makePath } from 'lib'
import { multipleWordsProps } from '../../../constants/Language'
import { useState } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../Settings'

const styles = theme => ({
})

const LanguageMenu = (props) => {
  const settingsContext = useContext(SettingsContext)

  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const history = useHistory()

  const handleClick = (event) => {
    setOpen(true)
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (event) => {
    setOpen(false)
    setAnchorEl(null)
  }

  const handleSelect = (value) => (event) => {
    settingsContext.setLanguage(value)
  
    history.push(makePath(history.location.pathname, value))
    setOpen(false)
    setAnchorEl(null)
  }

  var completeRate = {}
  Object.keys(LANGUAGE_SHORT_CODE).forEach(key => {
    let complete = multipleWordsProps.filter(wordProps => wordProps[LANGUAGE_SHORT_CODE[key]] !== undefined && wordProps[LANGUAGE_SHORT_CODE[key]] !== '' ).length
    let all = multipleWordsProps.length
    completeRate[[LANGUAGE_SHORT_CODE[key]]] = Math.round((complete / all) * 100)
  })

  return (
    <React.Fragment>
      <IconButton color="inherit" onClick={handleClick}>
        <LanguageIcon color="inherit"/>
      </IconButton>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        {languageProps.map(prop => 
          <MenuItem onClick={handleSelect(prop.value)} key={prop.value}>
            <ListItemText primary={`${prop.label} ( ${completeRate[prop.value]}% )`}/>
          </MenuItem>
        )}
      </Menu>
    </React.Fragment>
  )
}

export default withRouter(withStyles(styles, { withTheme: true })(LanguageMenu))



// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/components/LanguageMenu.js